import {forwardRef, Inject, Injectable} from '@angular/core';
import {JSonResult,} from '../model/common.model';
import {SessionService} from './session.service';
import {TranslateService} from '@ngx-translate/core';
import {JSonSerializer} from '../model/JSonSerializer';
import {Router} from "@angular/router";
import {ZohoToken} from "../model/ZohoToken";
import {ZohoResult} from "../model/ZohoResult";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {ScheduleAndTSPerEmployeeAggregation} from "../model/ScheduleAndTSPerEmployeeAggregation";

@Injectable()
export class ZohoService {

  // private _serverConfiguration: ServerConfiguration;
  //
  // private _canTrace = false;

  private _config = null;

  private _zohoToken: ZohoToken;

  private _zohoAuthorizationCode: string;

  private _zohoAccountsServer: string;
  private _zohoLocation: string;

  constructor(private http: HttpClient,
                @Inject(forwardRef(() => Router)) private router: Router,
                @Inject(forwardRef(() => TranslateService)) private translate: TranslateService,
                @Inject(forwardRef(() => SessionService)) private session: SessionService) {

    // this._config.clientId = '1000.1ZLOQGTWKLS7348898MUHND34784A2';
    // this._config.redirectUrl = 'http://localhost:4200/#/halfGod/zohoOAuth';


    this.loadConfiguration().then((serverConfig)=>{
      this._config = serverConfig;
      if (this._config!=null){
        console.log('Found Zoho config.');
      }
    });

    // this._config.clientId = '1000.NPFNT4P09QOD99006ZBC3DJ0UB11VW';
    // this._config.redirectUrl = 'https://vpn.horarius.net:8443/client/#/halfGod/callbackOAuthZoho';
    // this._config.apiUrl='https://www.zohoapis.com/crm/v2/'


  }

  public get zohoConfigFound(){
    if (this._config!=null){
      return true;
    }
    return false;
  }

  public get authorizationCode(){
    return this._zohoAuthorizationCode;
  }

  public set authorizationCode(code: string){
    this._zohoAuthorizationCode = code;
  }

  public get accountsServer(){
    return this._zohoAccountsServer;
  }

  public set accountsServer(code: string){
    this._zohoAccountsServer = code;
  }

  public get location(){
    return this._zohoLocation;
  }

  public set location(code: string){
    this._zohoLocation = code;
  }




  public get zohoToken(){
    return this._zohoToken;
  }

  public isActive():boolean{
    if (this._zohoToken){
      if (!this.zohoToken.expired){
        return true;
      }else{
        // console.log('Not Expired');
      }
    }else{
      // console.log('ZohoToken is null.');
    }
    return false;
  }

  /*
  loadUIConfiguration(): Promise<UIConfiguration> {
    return this.http.get('ui-configuration.json',{headers : this._getHeaders() }).toPromise().then(

      // response => console.log('response ' + response.json().server + ' response.text ' + response.text() )
      response => {
        //console.log('loadConfiguration ' + JSON.stringify(response.json()));
        return response as UIConfiguration;
      },
      rejected => { console.log('*** Cant load ui-configuration.json'); return null;}
    );
  }

   */

  loadConfiguration(): Promise<ZohoConfig> {
            return this.http.get('zoho-configuration.json',{headers : this._getHeaders() }).toPromise().then(

                //response => console.log('response ' + response.json().server + ' response.text ' + response.text() )
                response => {
                              console.log('loadConfiguration ',response);
                              return response as ZohoConfig;
                            },
                rejected => { return {clientId: 'No Client Id.', callbackUrl: 'None',apiUrl: 'None'} ; }
            );
    }



  private _retrieveJSonHeaders():HttpHeaders{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'etag' : this.session.userInfo.etag , 'Accept-Language': this.session.userInfo.locale,'X-XSRF-TOKEN':this.session.xsrfToken});
    return headers;
  }

  private _retrieveJSonRequestOptions(){
    const options = { headers: this._retrieveJSonHeaders(), withCredentials:true };
    return options;
  }

  /*
  {0}";
       String module ="Accounts";
//        String recordId="734488000023875061";  //Karen Inc.
//        String recordId="734488000023875073"; // Karen's food
       String recordId="734488000023875067"; // Karen 999
       String url = MessageFormat.format(customUrl,module,recordId).trim();
//         String url = MessageFormat.format(customUrl,scope,CLIENT_ID,"offline","https://app.emprez.net/oauthcallback").trim();
       LOG.info("url: " + url);


       HttpGet get = new HttpGet(url);
       get.addHeader("Authorization","Zoho-oauthtoken " + manager.getZohoToken().getAccessToken());
   */

  private _getHeaders():HttpHeaders{
    // 180 days in seconds
    const headers = new HttpHeaders({'Strict-Transport-Security': 'max-age: 15552000; includeSubDomains'});
    console.log('Using _getHeaders, ' + headers.get('Strict-Transport-Security'));
    return headers;
  }

  private _retrieveZohoHeaders():HttpHeaders{
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept-Language': this.session.userInfo.locale,'Authorization':'Zoho-oauthtoken ' + this._zohoToken.access_token});
    return headers;
  }
 /*
  private _retrieveZohoOptions():RequestOptions{
    const options = new RequestOptions({ headers: this._retrieveZohoHeaders(), withCredentials:true });
    return options;
  }

  */


  private _handleRejected(rejected:any){
    console.log('rejected: ' + JSON.stringify(rejected));
    if (rejected.hasOwnProperty('status')){
      if (rejected['status']===0){
        return {success:false,description: this.translate.instant('TemporaryInternetConnectionError')};
      }else{
        return {success:false,description: rejected + '',data:rejected['status']};
      }
    }else{
      return {success:false,description: rejected + ''};
    }
  }

  public retrieveGrantTokenUrl(): string{

    console.log('Config: ',this._config);

     let scope = "ZohoCRM.settings.ALL,ZohoCRM.modules.ALL,ZohoInvoice.contacts.READ,ZohoInvoice.invoices.ALL,ZohoInvoice.settings.ALL,Aaaserver.profile.read";
  //  let scope = "ZohoCRM.settings.ALL,ZohoCRM.modules.ALL,ZohoInvoice.fullaccess.all,Aaaserver.profile.read";
    let typeAccess = 'offline';
    let res = 'https://accounts.zoho.com/oauth/v2/auth?scope='+scope+'&client_id=' + this._config.clientId;
    res += '&response_type=code&access_type='+typeAccess+'&redirect_uri=' + this._config.callbackUrl;

    console.log('Grant URL: ' + res);

    return res;
  }


  public serverUrl(url: string ): string {
    const urlComplete = this.session.serverConfiguration.server.concat(url);
    // console.log('CompleteUrl: ' + urlComplete);
    return urlComplete;
  }

  public zohoServerUrl(url: string):string{
    //'http://cors.io/?' +
    const urlComplete = this._config.apiUrl.concat(url);
    // console.log('CompleteUrl: ' + urlComplete);
    return urlComplete;
  }

  /*
   return this.http.post( this.serverUrl('getDaySalesCostObjectiveAggregationByDates'), {fromDt: from, toDt: to}, this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          return response as JSonResult<DaySalesCostObjectiveAggregation[]>;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
   */

  createZohoToken(authorization: string): Promise<JSonResult<ZohoToken>> {
    return this.http.post( this.serverUrl('createZohoToken'), {zohoGrantToken: authorization},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          console.log('response createZohoToken : ',response);
          // console.log('available Recipients: ' + JSON.stringify(response.json(), null, 2));
          const res = response as JSonResult<ZohoToken>;
          if (res.success){
            const serial = new JSonSerializer();
            this._zohoToken = new ZohoToken();
            serial.deserialize(res.data,this._zohoToken);
          }
          return res;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

  /**
   * How it should be done if Zoho was allowing us to use JavaScript (CORS enabled server)
   */
  /*
  __getAllAccounts():Promise<any[]>{
    return this.http.post( this.zohoServerUrl('Accounts'), {},  this._retrieveZohoOptions())
      .toPromise()
      .then((response: Response) => {
          console.log('response getAllAccounts : ' + response.json() + ' ' + response.text());
          const res = response.json().data;
          return res;
        },
        (rejected) => { return this._handleRejected(rejected); }
      );
  }

   */

  private _handleRejectedZoho(rejected:any){
    console.log('rejected: ' + JSON.stringify(rejected));
    if (rejected.hasOwnProperty('status')){
      if (rejected['status']===0){
        return {success:false,description: this.translate.instant('TemporaryInternetConnectionError'),info: null};
      }else{
        return {success:false,description: rejected + '',data:rejected['status'], info: null};
      }
    }else{
      return {success:false,description: rejected + '', info: null};
    }
  }

  getAllZohoAccounts(authorization: string,pageId: number=1): Observable<ZohoResult<any>> {

    return new Observable<ZohoResult<any>>((observer)=>{
      this.http.post<ZohoResult<any>>( this.serverUrl('getAllZohoAccounts'), {zohoAccessToken: authorization, page:pageId}, this._retrieveJSonRequestOptions())

        .subscribe({
            next: (response) => {
              observer.next(response);
              observer.complete();
              observer.unsubscribe();
            },
            error: (rejected) => {
              const zr = new ZohoResult();
              zr.data = rejected;
              observer.next(zr);
              observer.complete();
              observer.unsubscribe();
            }
          }
        );

    });
  }

  getZohoAccount(authorization: string, zohoId: string): Promise<ZohoResult<any>> {
    return this.http.post<ZohoResult<any>>( this.serverUrl('getZohoAccount'), {zohoAccessToken: authorization, id:zohoId},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          // console.log('response getAllZohoAccount : ' + response.json() + ' ' + response.text());
          console.log('response',response);
          return response;
        },
        (rejected) => { return this._handleRejectedZoho(rejected); }
      );
  }


  searchZohoAccount(authorization: string, toSearch: string): Promise<ZohoResult<any>> {
    return this.http.post<ZohoResult<any>>( this.serverUrl('searchZohoAccount'), {zohoAccessToken: authorization, toSearch:toSearch},  this._retrieveJSonRequestOptions())
      .toPromise()
      .then((response) => {
          console.log('response',response);
          return response;
        },
        (rejected) => { return this._handleRejectedZoho(rejected); }
      );
  }

}

class ZohoConfig {
  clientId: string;
  callbackUrl: string;
  apiUrl: string;
}


